import { config } from '../config'
import { Booking } from '../entity'

export const BaseBookingEvent = {
  context: config.context,
  data: null as unknown as Booking,
} as const
